import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="newsCollection";

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export default {
  saveOrUpdate:insert,

}